/** Plain-text form of an incident body, for excerpts and anywhere
 * markup cannot be rendered.
 *
 * Lives in lib/ rather than beside the Markdown component because
 * react-refresh requires a component file to export only components -
 * mixing the two breaks fast refresh for the whole module.
 */
export function stripMarkdown(text: string | undefined): string {
  return (text ?? "")
    .replace(/\*\*([^*\n]+)\*\*/g, "$1")
    .replace(/`([^`\n]+)`/g, "$1");
}
